import type { Dictionary, Regime } from "../types";
import { h, on } from "./dom";

/**
 * Art. 7 Abs. 3 DSGVO: withdrawing consent must be as easy as giving it. A footer link
 * that calls `ConsentKit.showPreferences()` satisfies that too — this handle exists so
 * compliance does not depend on the site owner remembering to add one.
 *
 * Under the US regime it carries "Your privacy choices" instead, which is the label CPRA
 * expects a persistent opt-out control to use.
 */
export function createRevisitButton(
  t: Dictionary,
  regime: Regime,
  onClick: () => void,
): HTMLElement {
  const button = h(
    "button",
    { type: "button", class: "ck-revisit", "aria-haspopup": "dialog" },
    [regime === "opt-out" ? t.us.revisit : t.revisit.label],
  );
  on(button, "click", onClick);
  return button;
}
